import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/Care-Registration.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { step1, step2, step3 } from "../../Constant";
import { loadStripe } from "@stripe/stripe-js";
import config from "../../config";
import StripeForm from "../../components/Stripe/StripeForm";
import { connect } from "react-redux";
import { AddPaymentMethodAction } from "../../redux/actions/paymentmethods";

const CareRegistration4 = ({ auth, addCard }) => {
    const navigate = useNavigate();

    const stripeTokenHandler = async (token) => {
        addCard(token).then(() => {
            navigate("/care-giver-registration-5?back=true");
        });
    };

    return (
        <>
            <Header />
            {/* <!-- Care Giver Registration Form --> */}
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>Care Giver Registration</h2>
                            <p>
                                You can register and connect with a specialist
                                caregiver or home-helper by following our 5-step
                                easy process.
                            </p>
                        </div>
                        <div className="tab_nav" role="tablist">
                            <span className="borderTop"></span>
                            <ul
                                className="navs nav-tabs"
                                id="myTab"
                                role="tablist"
                            >
                                <li className="nav-item">
                                    <span className="count">1</span>
                                    <h6>Service Selection</h6>
                                </li>

                                <li className="nav-item">
                                    <span className="count">2</span>
                                    <h6>Service Setup</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">3</span>
                                    <h6>Build Trust</h6>
                                </li>
                                <li className="nav-item active">
                                    <span className="count">4</span>
                                    <h6>Finalization</h6>
                                </li>
                                <li className="nav-item">
                                    <span className="count">5</span>
                                    <h6>Payment</h6>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div id="wizard">
                        <h6>Fourth</h6>
                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#">Terms of Service</a>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    type="button"
                                    className="btn mr-1"
                                    onClick={() =>
                                        navigate(
                                            "/care-giver-registration-3?back=true"
                                        )
                                    }
                                >
                                    Back
                                </button>
                                {/* <button
                                    className="btn"
                                    onClick={() => navigate("/")}
                                >
                                    Cancel
                                </button> */}
                            </div>
                        </div>
                        <section id="tabcontent" className="fourth_tab">
                            <div className="head_wrapper">
                                <h5>Finalization</h5>
                                <p>Background Check and Processing Fee</p>
                            </div>
                            <div className="finalize_steps">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="step_box">
                                            <div className="imgBox">
                                                <figure>
                                                    <img src={step1} alt="" />
                                                </figure>
                                            </div>
                                            <div className="txtDv">
                                                <h5>
                                                    Profile processing fee ($25)
                                                </h5>
                                                <p>
                                                    Save a payment card for a
                                                    one-time fee that goes
                                                    towards our quality
                                                    assurance process and is
                                                    non-refundable.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="step_box">
                                            <div className="imgBox">
                                                <figure>
                                                    <img src={step2} alt="" />
                                                </figure>
                                            </div>
                                            <div className="txtDv">
                                                <h5>
                                                    Authorize a background check
                                                </h5>
                                                <p>
                                                    Essential step for all
                                                    providers to be part of my
                                                    Home Helper & build trust
                                                    with clients.{" "}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="step_box">
                                            <div className="imgBox">
                                                <figure>
                                                    <img src={step3} alt="" />
                                                </figure>
                                            </div>
                                            <div className="txtDv">
                                                <h5>Submit your profile</h5>
                                                <p>
                                                    With these two steps
                                                    completed you're ready to
                                                    submit your profile! We'll
                                                    review it within 5 business
                                                    days.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="accordionThree">
                                <div className="card">
                                    <div className="card-header" id="formseven">
                                        <h5 className="mb-0">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                data-toggle="collapse"
                                                data-target="#formsevencollapse"
                                                aria-expanded="true"
                                                aria-controls="formsevencollapse"
                                            >
                                                <div className="care_dropdown">
                                                    <div className="header_bar">
                                                        <div className="icon_bar">
                                                            <h5 className="title">
                                                                Payment & Fee
                                                            </h5>
                                                        </div>
                                                        <div className="ques">
                                                            <p>
                                                                We will charge
                                                                your card on
                                                                completing this
                                                                step
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="drop">
                                                        <i
                                                            className="fa fa-angle-left"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </button>
                                        </h5>
                                    </div>
                                    <div
                                        id="formsevencollapse"
                                        className="collapse show"
                                        aria-labelledby="formseven"
                                        data-parent="#accordionThree"
                                    >
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div>
                                                        <StripeForm
                                                            stripeTokenHandler={
                                                                stripeTokenHandler
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </section>
                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#">Terms of Service</a>
                                </p>
                            </div>
                            <div className="button-group">
                                <button
                                    type="button"
                                    className="btn mr-1"
                                    onClick={() =>
                                        navigate(
                                            "/care-giver-registration-3?back=true"
                                        )
                                    }
                                >
                                    Back
                                </button>
                                {/* <button
                                    className="btn"
                                    onClick={() => navigate("/")}
                                >
                                    Cancel
                                </button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Care Giver Registration Form --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    addCard: async (stripeToken) =>
        dispatch(await AddPaymentMethodAction(stripeToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CareRegistration4);
